const PAID = "paid";
const UNPAID = "unpaid";
const NO_PAYMENT_REQUIRED = "no_payment_required";
export const SESSION_PAYMENT_STATUS = {
  PAID,
  UNPAID,
  NO_PAYMENT_REQUIRED
};
